/**
 * The unfiltered option, shared by both controls: it is a chip in the desktop
 * row and the first item of the mobile menu, and it doubles as the menu
 * trigger's label while nothing is selected. Both map it onto a `null` slug.
 */
export const ALL_SECTORS_LABEL = 'All';

/**
 * Stands in for the "All" chip's `null` slug in `data-sector-slug`, which has to
 * be a string. Not a real sector, so it can never collide with one.
 */
export const ALL_SECTORS_SLUG = 'all';
